export function getSession(key) {
  const item = sessionStorage.getItem(key);
  if (!item) return null;
  try {
    return JSON.parse(item);
  } catch (e) {
    return item;
  }
}

export function setSession(name, value) {
  const valueToStore = typeof value === 'object' ? JSON.stringify(value) : value;
  sessionStorage.setItem(name, valueToStore);
}

export function deleteSession(name) {
  sessionStorage.removeItem(name);
}
